export enum Routes {
  COMPANY = "/",
  USERS = "/users",
  GROUPS = "/groups",
  EXPERIENCES = "/experiences",
  EXTERNAL_LICENSES = "/external-licenses",
  INSIGHTS = "/insights",
}

export enum EExperienceTabs {
  OVERVIEW = "overview",
  USERS = "users",
  GROUPS = "groups",
}

export enum EGroupTabs {
  OVERVIEW = "overview",
  USERS = "users",
  EXPERIENCES = "experiences",
}

export enum EUserTabs {
  PROFILE = "profile",
  ROLES = "roles",
  GROUPS = "groups",
  EXPERIENCES = "experiences",
}

export enum EInsightsTabs {
  INTERNAL_USAGE = "internal-usage",
  EXTERNAL_USAGE = "external-usage",
  USER_LEVEL_DATA = "user-level-data",
}

export enum ELicenseTabs {
  OVERVIEW = "overview",
  WHITELIST = "whitelist",
}
